import { SubjectsMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenu/SubjectsMenu";

export { SubjectsMenu };
